import { HomeIcon } from "@heroicons/react/20/solid";
import { Link, useLocation, useParams } from "react-router-dom";
import useRoutesList from "../../../routes";

export default function BreadCrumb() {
  const location = useLocation();
  const pathName = location.pathname;
  const routesList = useRoutesList();
  const params = useParams();
  const crumbs = routesList
    ?.filter(({ path }) => pathName.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(params).length
        ? Object.keys(params).reduce(
            (path, param) => path.replace(`:${param}`, params[param]),
            path
          )
        : path,
      ...rest,
    }));

  if (crumbs.length <= 0) {
    return null;
  }

  return (
    <nav className="flex mx-auto max-w-full relative z-10" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-2">
        <li>
          <div>
            <Link
              to="/dashboard"
              className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {crumbs.map((crumb) => (
          <li key={crumb.name}>
            <div className="flex items-center">
              <svg
                className="h-5 w-5 flex-shrink-0 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <Link
                to={crumb.path}
                className="ml-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors duration-200"
                aria-current={crumb.current ? "page" : undefined}
              >
                {crumb.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
